import React, { useState, useEffect } from 'react';
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import UnpickedAds from "./UnpickedAds";
import MyAds from "./MyAds/MyAds";
import AllAds from "./AllAds";
import { useTableState } from './utils/useTableState';
const DesignerTab = () => {
    const [activeTab, setActiveTab] = useState('my-ads');
    const { closeExpandedRows, adCounts, fetchAdCounts } = useTableState();
    const handleTabChange = (event) => {
        closeExpandedRows();;
        const newTab = event.detail.name;
        setActiveTab(newTab);
    };

    useEffect(() => {
        fetchAdCounts();
        const intervalId = setInterval(fetchAdCounts, 5 * 1000); // for every 5 seconds
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div >
            <SlTabGroup onSlTabShow={handleTabChange}>
                <SlTab slot="nav" panel="my-ads">My Ads <span className="text-blue-800 mx-1 py-1 px-2  rounded-full">{adCounts.myads}</span></SlTab>
                <SlTab slot="nav" panel="unpicked-ads">Unpicked Ads <span className="text-blue-800 mx-1 py-1 px-2  rounded-full">{adCounts.unpicked}</span></SlTab>
                <SlTab slot="nav" panel="all-ads">All Ads <span className="text-blue-800 mx-1 py-1 px-2 rounded-full">{adCounts.total}</span></SlTab>

                <SlTabPanel name="my-ads">
                    {activeTab === 'my-ads' && <MyAds key={activeTab} adCounts={adCounts} />}
                </SlTabPanel>
                <SlTabPanel name="unpicked-ads">
                    {activeTab === 'unpicked-ads' && <UnpickedAds key={activeTab} adCounts={adCounts} />}
                </SlTabPanel>
                <SlTabPanel name="all-ads">
                    {activeTab === 'all-ads' && <AllAds key={activeTab} />}
                </SlTabPanel>
            </SlTabGroup>
        </div>
    );
};

export default DesignerTab;
